import { forwardRef } from 'react';
import { breakpoints, Heading, Inline, Stack } from '@etg/wings';
import { BrandLogo, DangerousHtmlContent, ProgressSpinner } from '@eti/components';
import { useTranslation } from '@eti/providers';
import type { RegionNew } from '@eti/schema-types';
import { css } from '@eti/styles';
import { constants } from '@eti/utils';
import { useMediaQuery } from 'usehooks-ts';

const { brands } = constants;

const logoStyles = (brand: string) => css`
  display: block;
  max-width: ${brand === brands.ADR ? '150px' : '230px'};
  min-height: 30px;
`;

type TransitionContentProps = {
  brand: string;
  destination: RegionNew;
  siteName: string;
};

const TransitionContent = forwardRef<HTMLHeadingElement, TransitionContentProps>(
  function TransitionContent({ brand, destination, siteName }, ref) {
    const { t } = useTranslation();
    const isWiderViewport = useMediaQuery(`(min-width: ${breakpoints._970})`);

    return (
      <Stack>
        <Inline align="center">
          <BrandLogo
            brand={brand}
            className={logoStyles(brand)}
            shouldUseContrast
            siteName={siteName}
          />
        </Inline>
        <ProgressSpinner
          destinationIataCode={destination?.cityCode.toLowerCase()}
          size={isWiderViewport ? 280 : 240}
        />
        <Inline align="center">
          <Heading as="h3" level={4} ref={ref}>
            {t('PaymentPage.PaymentTransitionModal.Message')}
          </Heading>
        </Inline>
        <DangerousHtmlContent content={t('PaymentPage.PaymentTransitionModal.AdditionalText')} />
      </Stack>
    );
  },
);

export default TransitionContent;
